import { client } from "./index";

// Admin sign-in, profile and password endpoints (/api/auth)
export const login = (payload) => client.post("/auth/login", payload);
// A login that fits a partner and a store owner account sharing the email or mobile: the account picked
export const chooseAccount = (choiceToken, account) => client.post("/auth/login/choose", { choiceToken, account });
export const getMe = () => client.get("/auth/me");
export const updateProfile = (payload) => client.put("/auth/profile", payload);
export const changePassword = (payload) => client.post("/auth/change-password", payload);
export const logout = () => client.post("/auth/logout");
export const forgotPassword = (login) => client.post("/auth/forgot-password", { login });
export const resetPassword = (payload) => client.post("/auth/reset-password", payload);
// Login with a one-time code sent on WhatsApp to the account's mobile number
export const sendLoginOtp = (email) => client.post("/auth/otp/send", { email });
export const verifyLoginOtp = (email, otp) => client.post("/auth/otp/verify", { email, otp });
